import { withStyles, createStyles } from "@material-ui/core/styles";
import { TableCell } from "@material-ui/core";

export const BasicCell = withStyles(() =>
  createStyles({
    body: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: "0.5rem",
      paddingRight: "0.5rem",
      height: "2.5rem",
    },
  })
)(TableCell);

export const InputCell = withStyles(() =>
  createStyles({
    body: {
      backgroundColor: "rgba(218, 218, 218 , 0.3)",
    },
  })
)(BasicCell);

export const OutputCell = withStyles(() =>
  createStyles({
    body: {
      backgroundColor: "#b0dbfe",
    },
  })
)(BasicCell);

export const LightCell = withStyles(() =>
  createStyles({
    head: {
      backgroundColor: "rgba(218, 218, 218 , 1)",
    },
  })
)(TableCell);

export const DarkCell = withStyles(() =>
  createStyles({
    head: {
      backgroundColor: "#81cda1 ",
    },
  })
)(TableCell);
